module.exports = "./img/cd5ce334e3b7b4905f3dbbf093194be4.jpg";